module.exports = __webpack_public_path__ + "media/icons/opony-caloroczne-green@3x-dfafb22a.svg";